import {Injectable} from "@angular/core";
import {CometChatUIKit} from "@cometchat/chat-uikit-angular";
import {environment} from "../../../../environments/environment";
import {UIKitSettingsBuilder} from "@cometchat/uikit-shared";

@Injectable({
    providedIn: 'root'
})
export class ChatService {

    async init(uid: string): Promise<Object> {
        const appId = `${environment.cometchatAppId}`
        const region = `${environment.cometchatRegion}`
        const authKey = `${environment.cometchatAuthKey}`

        //create the builder
        const UIKitSettings = new UIKitSettingsBuilder()
            .setAppId(appId)
            .setRegion(region)
            .setAuthKey(authKey)
            .subscribePresenceForAllUsers()
            .build();

        //Initialize CometChat UI Kit
        await CometChatUIKit.init(UIKitSettings)
            .then(() => {
                console.log("Initialization completed successfully");
                // You can now call login function.

            })
            .catch(console.log);
        return this.login(uid)
    }

    async login(uid: string): Promise<Object> {
        const user = await CometChatUIKit.getLoggedinUser();

        if (user) {
            console.log("Logged out", user);
            await CometChatUIKit.logout();
        }

        const loggedInUser = await CometChatUIKit.login({ uid });
        console.log("Login Successful:", loggedInUser);
        return loggedInUser;
    }

    /*
    login(uid: string) {
        CometChatUIKit.getLoggedinUser().then(user => {
            if (user) {
                console.log("Logged out", user);
                CometChatUIKit.logout().then(() => {
                    CometChatUIKit.login({ uid: uid })
                        .then((user) => {
                            console.log("Login Successful:", { user });
                            // mount your app
                        })
                        .catch(console.log);
                })
            } else {
                console.log(uid)
                CometChatUIKit.login({ uid: uid })
                    .then((user) => {
                        console.log("Login Successful:", { user });
                        // mount your app
                    })
                    .catch(console.log);

            }
        })
    }

     */

    logout() {
        CometChatUIKit.logout().then(() => {
        })
    }
}
